import { MenuController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { Component } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { TranslateService } from '@ngx-translate/core';
import { CompanyRelation } from './enums/company-relation';
import { Company } from './interfaces/company';
import { CompanyService } from './services/company.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: 'Kalender', url: '/folder/Kalender', icon: 'calendar' },
    { title: 'Einstellungen', url: '/folder/Einstellungen', icon: 'construct' },
    { title: 'Wizard', url: '/folder/Wizard', icon: 'glasses' },
    // { title: 'Impressum', url: '/folder/Impressum', icon: 'analytics' },
    // { title: 'Datenschutz', url: '/folder/Datenschutz', icon: 'bag' },
  ];
  company: Company;
  // companyid: any;
  accountEmail: string = "";
  inIframe: boolean = true;

  public authenticated: boolean = true;
  token: any;
  colors: string[];
  constructor(
    private storage: Storage,
    private companyService: CompanyService,
    translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private menuCtrl: MenuController
  ) {
    this.authService.authenticationState.subscribe(res => {
      this.authenticated = res;
      if (this.company) {
        this.colors = [this.company.primary_color, this.company.secondary_color]
        let root = document.documentElement;
        if (this.colors[0] != undefined) {
          root.style.setProperty('--ion-color-primary', this.colors[0]);
        } else {
          root.style.setProperty('--ion-color-primary', 'grey');
        }
        if (this.colors[1] != undefined) {
          root.style.setProperty('--ion-color-secondary', this.colors[1]);
        } else {
          root.style.setProperty('--ion-color-secondary', 'goldenrod');
        }
      }
      this.menuCtrl.enable(this.authenticated);
      console.log("Authenticated: ", this.authenticated)
    })

    // translate.setDefaultLang('en');
    // const browserLanguage = translate.getBrowserLang();
    // translate.use(browserLanguage.match(/en|de/) ? browserLanguage : 'en');
  }

  async ngOnInit() {
    if (window.location !== window.parent.location) {
      this.inIframe = true;
    } else {
      this.inIframe = false
    }
    // If using a custom driver:
    // await this.storage.defineDriver(MyCustomDriver)

    // get company from JWT Token
    this.token = await this.authService.getDecodedUserToken();

    if (this.token && this.token.company) {
      this.accountEmail = this.token.email;//die email vom eingeloggtem User wird im Menu angezeigt
      console.log(this.accountEmail + 'accountEmail')
      console.log('app.components- comapny id', this.token.company);
      this.companyService
        .getCompanyById(this.token.company, CompanyRelation.ALL)
        .subscribe(async (x) => {
          this.company = x;
          if (this.company)
            this.storage.set(environment.storage.company, this.company);
          //await this.storage.set('companyType', x.category.name);
          this.storage.set(environment.storage.tags, x.tags);
        });
    } else {
      console.log('No company id available in storage');
    }
  }

  async logout() {
    await this.authService.logout();
  }
}
